<template>
  <div class="safe-container">
    <img :src="$dyyy(54)" alt="" @click="$router.push('/dyyy/safe/note')" />
    <div class="padding-lr-14">
      <div class="safe-card center-flex-y" v-for="item in menu" :key="item.id" @click="$router.push(item.path)">
        <div class="divider" v-if="item.tip">{{ item.tip }}</div>
        <div class="width-full flex justify-between align-center">
          <div>
            <div class="text-bold">{{ item.name }}</div>
            <div class="text-grey margin-top-6">{{ item.describe }}</div>
          </div>
          <img :src="$dyyy(item.icon)" width="62px" height="62px" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      menu: [
        // {
        //   id: 1,
        //   name: '拒绝线下交易',
        //   describe: '安全无保障 纠纷难处理',
        //   icon: '6',
        //   tip: '安全小知识',
        //   path: '/dyyy/safe/no-inline'
        // },
        {
          id: 4,
          name: '易游出行小宝典',
          describe: '8个小事记心中 平安回家路',
          icon: '47',
          path: '/dyyy/safe/note'
        },
        {
          id: 2,
          name: '安全功能全知道',
          describe: '你必须掌握的6大安全工具',
          icon: '7',
          tip: '安全功能',
          path: '/dyyy/safe/tool'
        },
        {
          id: 3,
          name: '110报警功能说明',
          describe: '紧急不慌张 快速寻帮助',
          icon: '8',
          path: '/dyyy/safe/police'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.safe-container {
  min-height: 100vh;
  background-color: #fff;
}
.safe-card {
  margin-top: 14px;
  padding: 20px;
  box-shadow: 0 0 6px 0px $grey3;
  border-radius: 2px;
}

.divider {
  position: relative;
  color: $grey;
  margin-bottom: 20px;
  &::before,
  &::after {
    content: "";
    display: block;
    position: absolute;
    width: 80px;
    height: 1px;
    background-color: $grey;
    top: 50%;
    transform: scaleY(0.5) translateY(-50%);
  }
  &::before {
    left: -96px;
  }
  &::after {
    right: -96px;
  }
}
</style>
